import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/daeiakbep053ijub1cbg";

type Status = "idle" | "loading" | "success" | "error";

export default function NewsletterForm({ variant = "dark" }: { variant?: "dark" | "light" }) {
  const [status, setStatus] = useState<Status>("idle");
  const [msg, setMsg] = useState("");

  const dark = variant === "dark";

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = String(fd.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMsg("订阅成功，感谢你的关注！");
      return;
    }
    fd.delete("website_alt");
    if (status === "loading") return;
    setStatus("loading");
    setMsg("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const meta = parsed?.meta as Record<string, unknown> | undefined;
      const serverMsg = (meta?.message as string) || (parsed?.message as string) || "";
      const code = parsed?.code as string | undefined;
      const isSpam =
        serverMsg.toLowerCase().includes("spam") || responseText.toLowerCase().includes("spam");

      if (res.ok && code === "OK" && !isSpam) {
        setStatus("success");
        setMsg("订阅成功，感谢你的关注！");
        form.reset();
      } else {
        setStatus("error");
        setMsg(serverMsg || "订阅失败，请稍后再试或检查邮箱格式。");
      }
    } catch {
      setStatus("error");
      setMsg("网络异常，请稍后再试。");
    }
  };

  return (
    <form data-readdy-form="newsletter" onSubmit={onSubmit}>
      <div className="flex flex-col gap-3 sm:flex-row">
        <input
          type="email"
          name="email"
          required
          placeholder="输入你的邮箱地址"
          className={`h-11 flex-1 rounded-xl border px-4 text-sm outline-none transition-colors ${
            dark
              ? "border-background-50/20 bg-background-50/10 text-background-50 placeholder:text-background-100/50 focus:border-accent-400"
              : "border-background-200 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:border-primary-300"
          }`}
        />
        <input
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          value=""
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl px-6 text-sm font-semibold transition-colors disabled:opacity-70 ${
            dark
              ? "bg-accent-500 text-foreground-950 hover:bg-accent-400"
              : "bg-primary-500 text-background-50 hover:bg-primary-600"
          }`}
        >
          {status === "loading" ? "订阅中..." : "订阅瓜讯"}
          <i className="ri-send-plane-line"></i>
        </button>
      </div>
      {status === "success" && (
        <p
          className={`mt-3 rounded-lg px-3 py-2 text-xs ${
            dark ? "bg-accent-500/15 text-accent-100" : "bg-secondary-100 text-secondary-800"
          }`}
        >
          <i className="ri-checkbox-circle-line mr-1"></i>
          {msg}
        </p>
      )}
      {status === "error" && (
        <p
          className={`mt-3 rounded-lg px-3 py-2 text-xs ${
            dark ? "bg-primary-500/20 text-accent-100" : "bg-primary-100 text-primary-800"
          }`}
        >
          <i className="ri-error-warning-line mr-1"></i>
          {msg}
        </p>
      )}
      <p className={`mt-2 text-xs ${dark ? "text-background-100/50" : "text-foreground-400"}`}>
        每周一次，退订自由，绝不打扰。
      </p>
    </form>
  );
}